var HierarchyMenu = (function($) {

    function getSiblings(oNode) {
        var $tds = $(oNode).closest('table').find('td');
        return _.filter($tds.get(), function(td) {
            return td!==oNode;
        });
    }

    function getNodes(oContainer) {
        return oContainer.getElementsByTagName('td');
    }

    function hierarchy(name) {
        this.expandedNode=null;
        this.triggerCollapse=null;

        this.built=false;
        this.name=name;

        this.direction = 'vertical';
        this.face = 'right';
        this.collapseDelay = 0.1;
        this.hover = 'enabled';

        this.source = $('#hierarchy'+name).html().trim();
        this.mark = $('#menuMark'+name);
        this.container = $('body');
    }






    hierarchy.prototype.load = function load() {
        var self = this;

        if (this.future) {
            return this.future;
        }

        this.future = $.get(window.global_rootAdmin+'/menu.htm?menu='+this.name, {cache: false}).then(function(resp) {
            self.source = resp;
            return self.build();
        });

        return this.future;
    };


    hierarchy.prototype.build = function build() {
        var el, dfd = $.Deferred();
        dfd.resolve();

        if (this.built) return dfd.promise();

        el = $(this.source).get(0);

        this.face = ((el.getAttribute('face'))&&(el.getAttribute('face').toLowerCase()==='left')) ? 'left':'right';
        this.direction = ((el.getAttribute('direction'))&&(el.getAttribute('direction').toLowerCase()==='horizontal')) ? 'horizontal':'vertical';
        this.collapseDelay = el.getAttribute('collapseDelay') || 0.1;


        el.hover= (el.getAttribute('hover')) ? el.getAttribute('hover').toLowerCase() : 'enabled';

        var oParsed = el.children[0];


        var oMenu=this.parseNodes(oParsed, null, null, null);
        if (!oMenu) return dfd.promise();


        this.rootNode = document.createElement("div");
        this.rootNode.attachedNodes = oMenu;
        oMenu.ownerNode = this.rootNode;

        $(this.rootNode).css({
            position: 'absolute',
            top: 0,
            left: 0,
            visibility: 'hidden',
            zIndex: 1000
        });

        this.container.append(this.rootNode);
        this.built = true;

        return dfd.promise();
    };

    hierarchy.prototype.realshow = function realshow(x, y) {
        if (!this.rootNode) return;

        $(this.rootNode).position({
            of: this.mark,
            my: 'left top',
            at: 'left bottom'
        });

        this.expandNode(this.rootNode);
    };

    hierarchy.prototype.show = function show(x, y) {
        var self = this;
        if (self.source) {
            self.build().then(function() {
                self.realshow();
            });
        } else {
            self.load().then(function() {
                self.realshow();
            });
        }
    };
    hierarchy.prototype.hide = function hide() {
        this.cancelCollapseMenu();

        this.collapseNode(this.rootNode);
        this.expandedNode=null;
    };

    hierarchy.prototype.collapseNode = function collapseNode(oNode) {
        if (!oNode) return;

        var i,l;
        if (oNode.collapsedClass)
            oNode.className=oNode.collapsedClass;


        if ( (oNode.attachedNodes)&&($(oNode.attachedNodes).is(":visible")) ) {
            $(oNode.attachedNodes).hide();
            var subnodes = getNodes(oNode.attachedNodes);
            for (i=0, l=subnodes.length; i<l; i++) {
                this.collapseNode(subnodes[i]);
            }
        }
        this.expandedNode=null;
    };


    hierarchy.prototype.initiateCollapseMenu = function initiateCollapseMenu() {
        this.triggerCollapse = setTimeout(_.bind(this.hide, this), this.collapseDelay*1000);
    };

    hierarchy.prototype.cancelCollapseMenu = function cancelCollapseMenu() {
        if (!this.triggerCollapse) return;
        clearTimeout(this.triggerCollapse);
        this.triggerCollapse = null;
    };

    hierarchy.prototype.fireNode = function fireNode(oNode) {
        if (oNode.action) {
            eval(oNode.action);
        }
    };


    hierarchy.prototype.expandNode = function expandNode(oNode) {
        this.cancelCollapseMenu();

        var oSubnodes = oNode.attachedNodes;

        if ((oSubnodes)&&(oSubnodes.delayed)) {
            this.parseNodes(oSubnodes.delayed, oSubnodes.xContainer, oSubnodes.xOwnerLabel, oSubnodes);
            oSubnodes.delayed=null;
        }


        var siblings=getSiblings(oNode);
        for (var i=0;i<siblings.length;i++) {
            this.collapseNode(siblings[i]);
        }
        this.collapseNode(oNode);

        if (oNode.expandedClass) {
            switch (this.hover) {
                case 'disabled' : break;
                case 'action':
                    if (oNode.action)
                        oNode.className=oNode.expandedClass;
                    break;

                case 'enabled' :
                default :
                    oNode.className=oNode.expandedClass;
            }
        }

        if (oSubnodes) {
            $(oSubnodes).show();

            var myhr = 'left',
                athr = oSubnodes.horizontal || 'right';

            if ((this.face==='left')&&(!oSubnodes.horizontal)) {
                myhr = 'right';
                athr = 'left';
            }

            var ox = oSubnodes.offsetX;
            if (ox) {
                myhr+= (ox>0) ? '+'+ox : ox;
            }

            $(oSubnodes).position({
                of: oNode,
                my: myhr+' top',
                at: athr+' '+oSubnodes.vertical+'-1'
            });

        }

        this.expandedNode = oNode;
    };

    hierarchy.prototype.parseNodes = function parseNodes(oParsed, xContainer, xOwnerLabel, oNodes) {
        if (!oNodes) {
            oNodes=document.createElement("div");
            oNodes.isNodes=true;
            $(oNodes).css({
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1000
            }).hide();

            if (oParsed.delay) {
                oNodes.delayed=oParsed;
                oNodes.xContainer=xContainer;
                oNodes.xOwnerLabel=xOwnerLabel;
                return oNodes;
            }
        }

        if (oParsed.className) {
            oNodes.className=oParsed.className;
        } else {
            if ((xContainer)&&(xContainer.className))
                oNodes.className=xContainer.className;
        }


        oNodes.offsetX= (oParsed.getAttribute('dx')) ? parseInt(oParsed.getAttribute('dx'), 10):  0;
        oNodes.horizontal= oParsed.getAttribute('horizontal');
        oNodes.vertical= oParsed.getAttribute('vertical') || 'top';
        oNodes.layout= oParsed.getAttribute("layout") || 'vertical';


        var aItems = [], oChild,
            prevIsSep = true,
            i, l;

        for (i=0, l=oParsed.children.length; i < l; i++) {
            oChild = oParsed.children[i];

            switch (oChild.tagName.toLowerCase()) {
                case 'node' : case 'nps:node' :
                    aItems.push(this.parseNode(oChild, oNodes, xOwnerLabel));
                    prevIsSep=false;
                    break;

                case 'separator' : case 'nps:separator' :
                    if ((!prevIsSep)&&(i!=l-1)&&(oParsed.children[i+1].tagName!='separator')) {
                        aItems.push(oChild);
                        prevIsSep=true;
                    }
                    break;
            }
        }

        if (!aItems.length)
            return null;

        var oTable=this.buildHTMLNode(aItems, {
            layout: oParsed.getAttribute("layout")
        });

        oNodes.appendChild(oTable);
        this.container.append(oNodes);

        return oNodes;
    };

    hierarchy.prototype.parseNode = function parseNode(oNode, xContainer, xOwnerLabel) {
        var i,l, oItem = {
            label: null,
            subnodes: null,
            nodeId: oNode.id,
            isNode: true
        }, chs = oNode.children;


        for (i=0, l=chs.length; i<l; i++) {
            switch (chs[i].tagName.toLowerCase()) {
                case 'label' : case 'nps:label' :
                    oItem.label=chs[i];
                    oItem.label.expanded = oItem.label.getAttribute('expanded');

                    if (xOwnerLabel) {
                        oItem.label.className= oItem.label.className || xOwnerLabel.className;
                        oItem.label.expanded= oItem.label.expanded || xOwnerLabel.expanded;
                    }
                    break;

                case 'action' : case 'nps:action' :
                    oItem.action=oNode.children[i].innerHTML;
                    break;

                case 'nodes' : case 'nps:nodes' :
                    var oSubnodes = this.parseNodes(oNode.children[i], xContainer, oItem.label);
                    if (oSubnodes)
                        oItem.subnodes=oSubnodes;
                    break;

                case 'json' : case 'nps:json' :
                    if (oNode.children[i].innerText.trim()) {
                        var json = JSON.parse(oNode.children[i].innerText);

                        var action = null;
                        if (json.library) {
                            action = function(node) {
                                return "fnSetNode('"+ json.id +"','"+ json.library +"','"+ node.id +"')";
                            };
                        } else if (json.structure) {
                            action = function(node) {
                                return node.id && "fnSetDocument2('"+ node.id +"')";
                            };
                        }


                        var oSubnodes = this.buildNodesFromJSON(json, xContainer, oItem.label, {actions: action});
                        if (oSubnodes)
                            oItem.subnodes=oSubnodes;
                    }
                    break;
            }
        }
        return oItem;
    };

    hierarchy.prototype.buildNodesFromJSON = function buildNodesFromJSON(json, xContainer, xOwnerLabel, opts) {
        var self = this;
        var oNodes =oNodes=document.createElement("div");

        oNodes.isNodes=true;
        $(oNodes).css({
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1000
        }).hide();

        if (json.className) {
            oNodes.className=json.className;
        } else {
            if ((xContainer)&&(xContainer.className))
                oNodes.className=xContainer.className;
        }


        oNodes.offsetX= (json.dx) ? +json.dx:  0;
        oNodes.horizontal= json.horizontal;
        oNodes.vertical= json.vertical || 'top';
        oNodes.layout= json.layout || 'vertical';

        var aItems = [], oChild, tagname,
            prevIsSep = true,
            i, l;

        for (i=0, l=json.nodes.length; i < l; i++) {
            oChild = json.nodes[i];
            tagname = oChild.tagName || 'node';

            switch (tagname.toLowerCase()) {
                case 'separator' : case 'nps:separator' :
                    if ((!prevIsSep)&&(i!=l-1)&&(json.nodes[i+1].tagName!='separator')) {
                        aItems.push(oChild);
                        prevIsSep=true;
                    }
                    break;

                default:

                    if (oChild.ghosted) {
                        if (oChild.nodes) {
                            oChild.nodes.forEach(function(subn) {
                                aItems.push(self.buildNodeFromJSON(subn, oNodes, xOwnerLabel, opts));
                            })
                        }
                    } else {
                        aItems.push(self.buildNodeFromJSON(oChild, oNodes, xOwnerLabel, opts));
                    }
                    prevIsSep=false;
                    break;
            }
        }

        if (!aItems.length)
            return null;

        var oTable=this.buildHTMLNode(aItems, {
            layout: json.layout
        });

        oNodes.appendChild(oTable);
        this.container.append(oNodes);

        return oNodes;
    };
    hierarchy.prototype.buildNodeFromJSON = function buildNodeFromJSON(json, xContainer, xOwnerLabel, opts) {
        var i,l, oItem = {
            label: null,
            subnodes: null,
            nodeId: json.id,
            isNode: true
        };

        if (json.label) {
            oItem.label = {
                innerHTML: json.label
            };
            if (xOwnerLabel) {
                oItem.label.className= oItem.label.className || xOwnerLabel.className;
                oItem.label.expanded= oItem.label.expanded || xOwnerLabel.expanded;
            }
        }
        if (json.nodes) {
            var subjson = json;
            if (json.divided) {
                subjson = {};
                subjson.nodes = _.flatten(_.map(json.nodes, function(n) {
                    return n.nodes;
                }));
            }

            var oSubnodes = this.buildNodesFromJSON(subjson, xContainer, oItem.label, opts);
            if (oSubnodes)
                oItem.subnodes=oSubnodes;
        }

        oItem.action = opts.actions && opts.actions(json);

        return oItem;
    };


    hierarchy.prototype.buildHTMLNode = function buildHTMLNode(aItems, opts) {
        var oTable=$("<table cellspacing='0' cellpadding='0' border='0'></table>").get(0),
            aTDS=[],
            oTR, oTD, oItem, oSep;

        opts = opts || {};

        if (opts.layout != 'horizontal') {
            for (i=0, l=aItems.length; i<l; i++) {
                oTR = oTable.insertRow(-1);
                aTDS[i] = oTR.insertCell();
            }
        } else {
            oTR = oTable.insertRow();
            for (i=0, l=aItems.length; i<l; i++)
                aTDS[i] = oTR.insertCell(-1);
        }


        for (i=0, l=aItems.length; i<l; i++) {
            oTD = aTDS[i];
            oItem = aItems[i];

            if (oItem.isNode) {
                if (oItem.label) {
                    if (oItem.label.className)
                        oTD.className=oItem.label.className;
                    if (oItem.label.expanded)
                        oTD.expandedClass=oItem.label.expanded;

                    oTD.innerHTML=oItem.label.innerHTML;
                }
                if (oItem.nodeId)
                    oTD.id=oItem.nodeId;
                if (oItem.action)
                    oTD.action=oItem.action;

                if (oTD.className)
                    oTD.collapsedClass=oTD.className;

                oTD.noWrap=true;

                oTD.onmouseover=_.bind(this.expandNode, this, oTD);
                //oTD.onmouseout=_.bind(this.initiateCollapseMenu, this);
                oTD.onclick=_.bind(this.fireNode, this, oTD);

                if (oItem.subnodes) {
                    oItem.subnodes.ownerNode=oTD;
                    oTD.attachedNodes=oItem.subnodes;
                }
            } else {
                oSep=document.createElement("img");
                oSep.src='/global/images/empty.gif';
                oSep.className=oItem.className;

                oTD.isNode=false;
                oTD.appendChild(oSep);
                if (oItem.align)
                    oTD.align=oItem.align;
                if (oItem.valign)
                    oTD.align=oItem.valign;
                oTD.onmouseover=this.cancelCollapseMenu;
            }
        }

        return oTable;
    }


    var menus = {};
    function moduleHandler(name) {
        menus[name] = menus[name] || new hierarchy(name);
        return menus[name];
    }
    function moduleShow(name) {
        _.invoke(menus, 'hide');
        moduleHandler(name).show();
    }
    function modulePreload(name) {
        moduleHandler(name).load();
    }
    function moduleCollapse(name) {
        if (!menus[name]) return;
        moduleHandler(name).initiateCollapseMenu();
    }
    function moduleHide() {
        _.invoke(menus, 'hide');
    }

    return {
        show: moduleShow,
        preload: modulePreload,
        collapse: moduleCollapse,
        hide: moduleHide,
        handler: moduleHandler
    };

})(jQuery);